import { MessageSquare, PlusCircle, Trash2, History } from "lucide-react";

/**
 * Left rail — session history list with new/delete actions.
 */
export default function SessionsRail({ sessions, sessionId, onNewChat, onLoad, onDelete }) {
  return (
    <div className="w-44 border-r border-slate-200 flex flex-col" data-testid="ai-sessions-rail">
      <div className="p-3 border-b border-slate-200 flex items-center gap-2">
        <History size={14} className="text-[#64748B]" />
        <div className="text-xs font-display font-semibold">Sessions</div>
        <button
          data-testid="new-chat"
          onClick={onNewChat}
          className="ml-auto text-[#00E5FF] hover:scale-110 transition-transform"
          title="New session"
        >
          <PlusCircle size={16} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-1" data-testid="sessions-list">
        {sessions.length === 0 ? (
          <div className="text-xs text-[#94A3B8] p-2">No history yet.</div>
        ) : (
          sessions.map((s) => (
            <button
              key={s.session_id}
              data-testid={`session-${s.session_id}`}
              onClick={() => onLoad(s.session_id)}
              className={`group w-full text-left rounded-xl px-2 py-2 text-xs transition-all flex items-start gap-2 ${
                sessionId === s.session_id
                  ? "glass-active text-[#00E5FF]"
                  : "glass text-[#64748B] hover:text-[#0F172A]"
              }`}
            >
              <MessageSquare size={12} className="mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="truncate leading-tight">{s.title || "Session"}</div>
                <div className="text-[10px] text-[#94A3B8] mt-0.5">{s.provider}</div>
              </div>
              <button
                onClick={(e) => onDelete(s.session_id, e)}
                className="opacity-0 group-hover:opacity-100 text-[#94A3B8] hover:text-[#FF6B9D] shrink-0"
                aria-label="Delete session"
              >
                <Trash2 size={11} />
              </button>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
